<span [class]="orderStatusClass()">{{ orderStatusText() }}</span>
